import {
  AssociationItem,
  EditorialPerInitiative,
  UsefulLink,
} from "../AddActivity/types";
import { SelectedLOItem } from "../types";

export type PropaedeuticLogic = "FIRST" | "FREE" | "SEQUENTIAL" | "LAST_LOCKED";

export type ComplexityLevel = "BASE" | "MEDIUM" | "ADVANCED";

export type TestLogic = "WITH_ZEROING" | "FREE";

export type SelectedActivity = SelectedLOItem & { kind: "activity" };

export type CompletionCriterion =
  | "LO_TO_COMPLETE"
  | "MIN_COMPLETION_PERC"
  | "COMPLETION_MINUTES"
  | "COMPLETION_MINUTES_PERC";

export interface CourseWizardData {
  title: string;
  digited_code: string;
  description: string;

  allow_post_publish_additions: boolean;

  is_standalone: boolean;
  schedule_publication: boolean;
  publish_date: string | null;
  obsolescent_date: string | null;

  propaedeutic_logics: PropaedeuticLogic | null;

  completion_criterion: CompletionCriterion | null;

  completion_value: string;

  cover_id: AssociationItem | null;
  video_id: AssociationItem | null;

  certificate_ids: AssociationItem[];
  signature_certificate_ids: AssociationItem[];
  badge_id: AssociationItem | null;
  complexity: string | null;
  score: string;
  credits: string;
  lo_tag: string[];
  useful_links: UsefulLink[];
  stakeholders: {
    userId?: number;
    name?: string;
    type: string;
    visStakeholder: boolean;
  }[];
  didactical_material: AssociationItem[];
  selected_activities: SelectedActivity[];
  test_id: AssociationItem | null;
  survey_id: AssociationItem | null;
  test_logic: TestLogic | null;
  test_min_score: string;
  max_attempt: string;

  selected_initiatives: AssociationItem[];

  editorial_per_initiative: Record<number, EditorialPerInitiative>;
  highlight_explore: boolean;
}

export const EMPTY_COURSE_DATA: CourseWizardData = {
  title: "",
  digited_code: "",
  description: "",
  allow_post_publish_additions: false,
  is_standalone: false,
  schedule_publication: false,
  publish_date: null,
  obsolescent_date: null,
  propaedeutic_logics: null,
  completion_criterion: null,
  completion_value: "",
  cover_id: null,
  video_id: null,

  certificate_ids: [],
  signature_certificate_ids: [],
  badge_id: null,
  complexity: null,
  score: "",
  credits: "",
  lo_tag: [],
  useful_links: [],
  stakeholders: [],
  didactical_material: [],

  selected_activities: [],

  test_id: null,
  survey_id: null,
  test_logic: null,
  test_min_score: "",
  max_attempt: "",

  selected_initiatives: [],

  editorial_per_initiative: {},
  highlight_explore: false,
};
